/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */

export const incompleteBlockClassName = " header-info "
export const completeBlocClassName = incompleteBlockClassName + " is-success "
export const formPartBaseClassName = " header-info "
export const formPartFinishedClassName = formPartBaseClassName + " is-success "
export const STEP_SUMMARY = "stepSummary"
export const contractTypeEnum = "IT1"
export const professionStudent = "IT094"
export const professionRetired = "IT090"
export const noProfession = "IT093"
export const missEnumCode = "2"
export const mademoiselleEnumCode = "3"
export const isSmallBusiness = false
export const ITALIANA = "1"
export const UNION_EUROPE = "2"
export const EXTRA_UNION_EUROPE = "3"
export const RICHIESTA_RINNOVO = "RR"
export const italian_order_language_tag = "it-IT"
export const spanish_order_language_tag = "es-ES"
export const SERVER_DATE_FORMAT = "YYYY-MM-DD"
export const CUSTOMER_DATE_FORMAT = "DD/MM/YYYY"
export const DATE_FORMAT = {
  identity: {
    birthDate: {
      FR: "DD/MM/YYYY",
      BE: "DD/MM/YYYY",
      IT: "DD/MM/YYYY",
      ES: "DD/MM/YYYY",
      PT: "DD/MM/YYYY",
      NL: "DD/MM/YYYY"
    },
    identificationExpirationDate: {
      FR: "DD/MM/YYYY",
      BE: "DD/MM/YYYY",
      IT: "DD/MM/YYYY",
      ES: "DD/MM/YYYY",
      PT: "DD/MM/YYYY",
      NL: "DD/MM/YYYY"
    }
  },
  coordinates: {
    yearBankSeniority: {
      FR: "YYYY",
      BE: "YYYY",
      ES: "YYYY",
      PT: "YYYY",
      NL: "YYYY"
    }
  },
  identityDocuments: {
    documentDateOfIssue: {
      IT: "DD/MM/YYYY",
      ES: "DD/MM/YYYY",
      PT: "DD/MM/YYYY"
    },
    residencePermitExpiryDate: {
      IT: "MM/YYYY"
    }
  },
  situation: {
    employmentDate: {
      FR: "YYYY",
      BE: "YYYY",
      IT: "MM/YYYY",
      ES: "MM/YYYY",
      PT: "MM/YYYY",
      NL: "YYYY"
    },
    residenceDate: {
      FR: "YYYY",
      BE: "YYYY",
      IT: "YYYY",
      ES: "YYYY",
      PT: "YYYY",
      NL: "YYYY"
    },
    endContractDate: {
      IT: "MM/YYYY"
    },
    yearBankSeniority: {
      IT: "YYYY",
      ES: "YYYY",
      PT: "YYYY",
      BE: "YYYY",
      NL: "YYYY"
    }
  }
}

const COLTIVATORE_ALLEVATORE = "IT001"
const COMMERCIANTE_IN_ALTRI_SETTORI = "IT010"
const ULTERIORI_CATEGORIE_DI_ARTIGIANI = "IT015"
const AMBULANTE = "IT019"
const INGEGNERE_MEDICO_ECC = "IT020"
const AREA_GIURID_COMMERCIALISTA = "IT021"
const EDILIZIA_PULIZIE_APPALTI_PUBBLICI = "IT023"
const AGENTE_IMMOBILIARE = "IT024"
const AGENTE_COMMERCIO_O_ASSICURAZIONI = "IT025"
const BENI_DI_LUSSO_ARMI_ALCOOL_TABACCHI_ELETTR = "IT028"
const LIBERA_PROFESSIONE_DIVERSA = "IT029"
const DIRIGENTE = "IT030"
const QUADRO_FUNZIONARIO = "IT031"
const CAMBIO_VALUTA_PEGNO_RIGATTIERE = "IT032"
const PRODUZIONE_DI_ARMI_TABACCHI_ALCOOLICI = "IT033"
const BAR_RISTORANTE_INTERNET_CAFE_HOTEL = "IT034"
const TASSISTA = "IT035"
const GIOCO_SCOMMESSE_CREAZ_SITI_PAG_SERV_INTERNET = "IT036"
const CALCIATORE_PROCUR_SPORTIVO = "IT037"
const PROPRIETARIO_CLUB_AMMINISTR = "IT038"
const ULTERIORI_SPORT_PROFESS_ATLETA_PROCUR_SPORT = "IT039"
const DIRIGENTE_MEDICO_PROFESSORE_UNIVERSITARIO = "IT040"
const QUADRO_INSEGNANTE = "IT041"
const ULTERIORI_SPORT_PROFESS_PROPR_CLUB_AMMINISTR = "IT042"
const OPERAIO_SPECIALIZZATO = "IT050"
const IMPIEGATO_COMMESSO_CON_SOLO_FISSO = "IT060"
const IMPIEGATO_COMMESSO_CON_FISSO_E_PROVVIGIONI = "IT065"
const DIPEND_PUBBL_ESERCIZI = "IT066"
const IMPIEGATO_OPERAIO_SPECIALIZZATO = "IT070"
const OPERAIO_PUBBL = "IT072"
const MILITARE_VOLONTARIO_SERVIZIO_VSP = "IT074"
const OPERAIO_PRIV = "IT080"
const AMMINISTR_DI_SOC_CON_CONTRATTO_A_PROGETTO = "IT088"
const BRACCIANTE_AGRICOLO = "IT089"
const PENSIONATO = "IT090"
const LOCATORE = "IT091"
const CASALINGA_SENZA_PROFESSIONE = "IT093"
const STUDENTE = "IT094"
const CO_CO_PRO = "IT096"
const SPORT_CALCIO_PROFESS = "IT097"
const SPORT_ULTERIORI_SPORT_PROFESSIONISTICI = "IT098"
const SCONOSCIUTA = "IT099"

export const DATA_INIZIO_LAVARO_NO_DISPLAY_PROFESSIONS = [CASALINGA_SENZA_PROFESSIONE, STUDENTE]
export const DATA_INIZIO_LAVARO_NO_VALIDATE_PROFESSIONS = [CASALINGA_SENZA_PROFESSIONE, STUDENTE, SCONOSCIUTA]

export const TIPO_DI_CONTRATTO_DETERMINATO_PROFESSIONS = [
  AMMINISTR_DI_SOC_CON_CONTRATTO_A_PROGETTO,
  SPORT_CALCIO_PROFESS,
  SPORT_ULTERIORI_SPORT_PROFESSIONISTICI,
  LOCATORE,
  CO_CO_PRO,
  BRACCIANTE_AGRICOLO
]
export const TIPO_DI_CONTRATTO_INDETERMINATO_PROFESSIONS = [
  AGENTE_COMMERCIO_O_ASSICURAZIONI,
  AGENTE_IMMOBILIARE,
  AMBULANTE,
  BAR_RISTORANTE_INTERNET_CAFE_HOTEL,
  BENI_DI_LUSSO_ARMI_ALCOOL_TABACCHI_ELETTR,
  CAMBIO_VALUTA_PEGNO_RIGATTIERE,
  COMMERCIANTE_IN_ALTRI_SETTORI,
  EDILIZIA_PULIZIE_APPALTI_PUBBLICI,
  GIOCO_SCOMMESSE_CREAZ_SITI_PAG_SERV_INTERNET,
  PRODUZIONE_DI_ARMI_TABACCHI_ALCOOLICI,
  TASSISTA,
  ULTERIORI_CATEGORIE_DI_ARTIGIANI,
  AREA_GIURID_COMMERCIALISTA,
  INGEGNERE_MEDICO_ECC,
  LIBERA_PROFESSIONE_DIVERSA,
  DIRIGENTE,
  CALCIATORE_PROCUR_SPORTIVO,
  PROPRIETARIO_CLUB_AMMINISTR,
  ULTERIORI_SPORT_PROFESS_ATLETA_PROCUR_SPORT,
  DIRIGENTE_MEDICO_PROFESSORE_UNIVERSITARIO,
  ULTERIORI_SPORT_PROFESS_PROPR_CLUB_AMMINISTR,
  COLTIVATORE_ALLEVATORE,
  PENSIONATO,
  CASALINGA_SENZA_PROFESSIONE,
  SCONOSCIUTA,
  STUDENTE
]
export const TIPO_DI_CONTRATTO_DETERMINATO_INDETERMINATO_PROFESSIONS = [
  IMPIEGATO_COMMESSO_CON_FISSO_E_PROVVIGIONI,
  IMPIEGATO_COMMESSO_CON_SOLO_FISSO,
  DIPEND_PUBBL_ESERCIZI,
  QUADRO_INSEGNANTE,
  MILITARE_VOLONTARIO_SERVIZIO_VSP,
  OPERAIO_PRIV,
  OPERAIO_PUBBL,
  OPERAIO_SPECIALIZZATO,
  IMPIEGATO_OPERAIO_SPECIALIZZATO,
  QUADRO_FUNZIONARIO
]
export const DATORE_CITTA_PROVINCIA_NO_DISPLAY_PROFESSIONS = [CASALINGA_SENZA_PROFESSIONE, STUDENTE, PENSIONATO]
export const DATORE_CITTA_PROVINCIA_NO_VALIDATE_PROFESSIONS = [
  CASALINGA_SENZA_PROFESSIONE,
  STUDENTE,
  PENSIONATO,
  LOCATORE,
  SCONOSCIUTA
]
export const REDITTO_MENSILE_IN_EURO_NO_DISPLAY_PROFESSIONS = [CASALINGA_SENZA_PROFESSIONE, STUDENTE]
export const REDITTO_MENSILE_IN_EURO_NO_VALIDATE_PROFESSIONS = [
  CASALINGA_SENZA_PROFESSIONE,
  STUDENTE,
  INGEGNERE_MEDICO_ECC,
  AREA_GIURID_COMMERCIALISTA,
  EDILIZIA_PULIZIE_APPALTI_PUBBLICI,
  AGENTE_IMMOBILIARE,
  AGENTE_COMMERCIO_O_ASSICURAZIONI,
  BENI_DI_LUSSO_ARMI_ALCOOL_TABACCHI_ELETTR,
  LIBERA_PROFESSIONE_DIVERSA,
  CAMBIO_VALUTA_PEGNO_RIGATTIERE,
  PRODUZIONE_DI_ARMI_TABACCHI_ALCOOLICI,
  BAR_RISTORANTE_INTERNET_CAFE_HOTEL,
  TASSISTA,
  GIOCO_SCOMMESSE_CREAZ_SITI_PAG_SERV_INTERNET,
  CALCIATORE_PROCUR_SPORTIVO,
  PROPRIETARIO_CLUB_AMMINISTR,
  ULTERIORI_SPORT_PROFESS_ATLETA_PROCUR_SPORT,
  ULTERIORI_SPORT_PROFESS_PROPR_CLUB_AMMINISTR,
  SCONOSCIUTA,
  COLTIVATORE_ALLEVATORE,
  COMMERCIANTE_IN_ALTRI_SETTORI,
  ULTERIORI_CATEGORIE_DI_ARTIGIANI,
  AMBULANTE
]
export const IDENTITY_DOCUMENT_TYPE_PATENTE = ["PT", "PE"]

/* durée par défaut sur la page service */
export const DEFAULT_DURATION_SERVICE_PAGE = 12
export const DEFAULT_DURATION_SERVICE_PAGE_RDC = 24

export const PROFESSION_WITHOUT_BUDGET_INFO_NL = ["Werkloos", "Student"]

// constant Samsung ES
export const WORKING_SECTOR_WITHOUT_PROFESSIONAL_USE = "Privado"
export const WORKING_SECTOR_AUTONOMO = "Autónomo"
export const WORKING_SECTOR_PUBLICO = "Público"
export const WORKING_SECTOR_PUBLICO_JUBILADO_PREJUBILADO = ["Público", "Jubilado (por edad)", "Prejubilado"]
export const WORKING_SECTOR_JUBILADO_PREJUBILADO_PENSIONISTA = ["Jubilado (por edad)", "Prejubilado", "Pensionista"]
export const PROFESSION_WITHOUT_PROFESSIONAL_USE = "Directivo"

export const PROFESSIONAL_USE_PRO = "Profesional"
export const PROFESSIONAL_USE_PERS = "Personal"

export const WORKING_SECTOR_UNIVERSITY_STUDENT_CISCLOS_NOTWORKING = [
  "Universitarios",
  "Master y doctorado",
  "Otros ciclos formativos",
  "No trabaja"
]
